import { useChurchDataProvider } from '@data/ChurchDataProvider'
import './index.scss'
import { useState } from 'react';
import CampusModal from './Modal/CampusModal';
import { Campus, Category } from '@data/ChurchDataProvider';
import LoadingIndicator from '@components/LoadingIndicator';
import DeleteCampusModal from './Modal/DeleteCampusModal';
import CategoryModal from './Modal/CategoryModal';
import PageTabs from '@components/PageTabs';

export default function Settings() {
  const churchData = useChurchDataProvider();
  const campuses = churchData.campuses;
  const categories = churchData.categories;
  const [isCampusModalOpen, setIsCampusModalOpen] = useState(false);
  const [campusForModal, setCampusForModal] = useState<Campus | null>(null);
  const [isDeleteCampusModalOpen, setIsDeleteCampusModalOpen] = useState(false);
  const [campusForDeleteModal, setCampusForDeleteModal] = useState<Campus | null>(null);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [categoryForModal, setCategoryForModal] = useState<Category | null>(null);
  const [isDeleteCategoryModalOpen, setIsDeleteCategoryModalOpen] = useState(false);
  const [categoryForDeleteModal, setCategoryForDeleteModal] = useState<Category | null>(null);
  const [newCampusModalKey, setNewCampusModalKey] = useState(0);
  const [newCategoryModalKey, setNewCategoryModalKey] = useState(0);

  const closeCampusModal = () => {
    setIsCampusModalOpen(false);

    window.setTimeout(() => {
      setCampusForModal(null);
    }, 200);
  };

  const closeDeleteCampusModal = () => {
    setIsDeleteCampusModalOpen(false);

    window.setTimeout(() => {
      setCampusForDeleteModal(null);
    }, 200);
  };

  const closeCategoryModal = () => {
    setIsCategoryModalOpen(false);

    window.setTimeout(() => {
      setCategoryForModal(null);
    }, 200);
  };

  const closeDeleteCategoryModal = () => {
    setIsDeleteCategoryModalOpen(false);

    window.setTimeout(() => {
      setCategoryForDeleteModal(null);
    }, 200);
  };

  if (!churchData.church || !churchData.campuses) {
    return <div className="settings-page">
      <LoadingIndicator />
    </div>
  }

  return <div className="settings-page">
    <CampusModal
      key={campusForModal?.id ?? `new-campus-${newCampusModalKey}`}
      isOpen={isCampusModalOpen}
      campus={campusForModal}
      close={closeCampusModal}
      onSaved={() => {
        churchData.reloadChurch();
        closeCampusModal();
      }}
    />

    <DeleteCampusModal
      key={campusForDeleteModal?.id ?? 'delete-campus'}
      isOpen={isDeleteCampusModalOpen}
      campus={campusForDeleteModal}
      close={closeDeleteCampusModal}
      onDeleted={() => {
        churchData.reloadChurch();
        closeDeleteCampusModal();
      }}
    />

    <CategoryModal
      key={categoryForModal?.id ?? `new-category-${newCategoryModalKey}`}
      isOpen={isCategoryModalOpen}
      category={categoryForModal}
      close={closeCategoryModal}
      onSaved={() => {
        churchData.reloadChurch();
        closeCategoryModal();
      }}
    />

    <DeleteCampusModal
      key={categoryForDeleteModal?.id ?? 'delete-category'}
      isOpen={isDeleteCategoryModalOpen}
      category={categoryForDeleteModal}
      close={closeDeleteCategoryModal}
      onDeleted={() => {
        churchData.reloadChurch();
        closeDeleteCategoryModal();
      }}
    />

    <PageTabs title="Settings"
      tabs={[]}
      buttons={[]} />

    <p className='section-header'>Campuses</p>
    <div className='section card'>
      {campuses.map((campus, index) => (
        <div key={campus.id}>
          {index > 0 && <div className='divider' />}
          <div className='campus'>
            <div className='campus-header'>
              <h3>{campus.attributes.name}</h3>
              <div className='campus-actions'>
                <button
                  className='inline-action-button'
                  onClick={() => {
                    setCampusForModal(campus);
                    setIsCampusModalOpen(true);
                  }}>
                  Edit
                </button>
                <button
                  className='inline-action-button danger'
                  onClick={() => {
                    setCampusForDeleteModal(campus);
                    setIsDeleteCampusModalOpen(true);
                  }}>
                  Delete
                </button>
              </div>
            </div>
            {campus.attributes.address && <div className='address'>
              <p>{campus.attributes.address.street}</p>
              <p>{campus.attributes.address.city}, {campus.attributes.address.state} {campus.attributes.address.zip}</p>
              <p>{campus.attributes.address.country}</p>
            </div>}
            {!campus.attributes.address && <p className='address'>No address</p>}
          </div>
        </div>
      ))}

      {campuses.length > 0 && <div>
        <div className='divider' />

        <button className='inline-action-button' onClick={() => {
          setCampusForModal(null);
          setNewCampusModalKey((currentKey) => currentKey + 1);
          setIsCampusModalOpen(true);
        }}>+ Add Campus</button>
      </div>}

      {campuses.length === 0 && <button className='inline-action-button' onClick={() => {
        setCampusForModal(null);
        setNewCampusModalKey((currentKey) => currentKey + 1);
        setIsCampusModalOpen(true);
      }}>+ Add Campus</button>}
    </div>

    <p className='section-header'>Categories</p>
    <div className='section card'>
      {categories.map((category, index) => (
        <div key={category.id}>
          {index > 0 && <div className='divider' />}
          <div className='category-row'>
            <h3>{category.name}</h3>
            <div className='campus-actions'>
              <button
                className='inline-action-button'
                onClick={() => {
                  setCategoryForModal(category);
                  setIsCategoryModalOpen(true);
                }}>
                Edit
              </button>
              <button
                className='inline-action-button danger'
                onClick={() => {
                  setCategoryForDeleteModal(category);
                  setIsDeleteCategoryModalOpen(true);
                }}>
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}

      {categories.length > 0 && <div>
        <div className='divider' />

        <button className='inline-action-button' onClick={() => {
          setCategoryForModal(null);
          setNewCategoryModalKey((currentKey) => currentKey + 1);
          setIsCategoryModalOpen(true);
        }}>+ Add Category</button>
      </div>}

      {categories.length === 0 && <button className='inline-action-button' onClick={() => {
        setCategoryForModal(null);
        setNewCategoryModalKey((currentKey) => currentKey + 1);
        setIsCategoryModalOpen(true);
      }}>+ Add Category</button>}
    </div>
  </div>
}
